import { compose, defaultTo, map, prop } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { PostmenSliceType } from '../../../../types/slice';
import { toRichTextFromProp, toTextFromProp } from '../../fields/text';

const ILLUSTATIONS = {
  Drapeau: 'flag',
  Carte: 'map',
  Numerique: 'numeric',
  Handicap: 'handicap',
  Formation: 'formation',
  Apprentissage: 'apprentissage',
};

const mapIllustrations = compose(
  clear,
  map(({ illustration, ...rest }) => ({
    illustration: prop(illustration, ILLUSTATIONS),
    title: toTextFromProp('title', rest),
    subtitle: toTextFromProp('subtitle', rest),
    description: toTextFromProp('description', rest),
  })),
  defaultTo([])
);

export const textIllustrationsSlice = ({ primary, items }) =>
  clear({
    type: PostmenSliceType.TXT_ILLUSTRATIONS,
    text: toRichTextFromProp('txt', primary),
    illustrations: mapIllustrations(items),
  });
